module.exports = __webpack_public_path__ + "img/bg.b47b422e.webp";